module.exports = __webpack_public_path__ + "img/pain-spot-1.dc7e78ad.svg";